// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-positive-negative {\n  display: flex;\n  align-items: center;\n  padding: 2px 4px;\n  background: #f7f8fa;\n  font-size: 12px;\n  border-radius: 2px;\n  min-width: 78px;\n}\n.common-positive-negative.is-positive {\n    color: #c81919;\n}\n.common-positive-negative.is-negative {\n    color: #009b37;\n}\n", ""]);
// Exports
module.exports = exports;
